module.exports = __webpack_public_path__ + "img/yl_icon.cb6279df.png";